import * as React from 'react';

const ReskillIcon = () => (
  <svg role="presentation" width="48" height="48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="24" cy="24" r="24" fill="#F5F7F8" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m23.989 8.683-5.98 5.98-.591-.592 6.989-6.99 6.989 6.99-.592.591-5.979-5.979V21.06h-.836V8.683zM24.824 40.127l5.979-5.979.591.592-6.988 6.989-6.99-6.99.592-.59 5.98 5.978V27.751h.836v12.376zM8.683 24.822l5.98 5.979-.592.592-6.99-6.99 6.99-6.988.591.591-5.979 5.98H21.06v.836H8.683zM39.291 24.822l-5.979 5.979.592.592 6.989-6.99-6.99-6.988-.59.591 5.978 5.98H26.915v.836h12.376z"
      fill="#1F1F1F"
    />
  </svg>
);

export default ReskillIcon;
